import React from "react";
import { Button } from "primereact/button";
import { useTranslation } from "react-i18next";
import RoleAccess from "../../Components/RoleAccess";
import PlanCreateKindMenu from "../../Components/PlanCreateKindMenu";

const ProductGroupActions = ({
  rowData,
  onShare,
  onEdit,
  onDuplicate,
  onArchive,
  onLeaderboard,
  onWatchers,
}) => {
  const { t } = useTranslation("common");

  if (!rowData) {
    return null;
  }

  const disableShare = !rowData?.tierObject?.tierName;
  const greyOut = !rowData.watcherCount;
  const hasLeaderboard = Boolean(rowData.boardUrl);

  return (
    <div className="car-buttons table_action_button">
      <Button
        icon="pi pi-share-alt"
        className="action-button"
        tooltip={t("product.share_url")}
        id={disableShare ? "disable-share-action-button" : "action-button"}
        onClick={() => onShare(rowData, disableShare)}
      />
      <RoleAccess roles={["OWNER", "ADMIN"]}>
        <PlanCreateKindMenu
          planGroup={rowData}
          disabled={rowData.status === "ARCHIVED"}
          buttonClassName={rowData.status !== "ACTIVE" ? "action-button" : "active-action-button"}
          tooltip={t("products.add_product")}
        />
        <Button
          icon="pi pi-pencil"
          disabled={rowData.status === "ARCHIVED"}
          className={`p-button ${rowData.status !== "ACTIVE"
            ? "action-button"
            : "active-action-button"
            }`}
          id="action-button"
          tooltip={t("product.edit_product")}
          tooltipOptions={{
            position: "bottom",
            mouseTrack: true,
            mouseTrackTop: 15,
          }}
          onClick={() => onEdit(rowData)}
        />
        <Button
          icon="pi pi-copy"
          className="action-button"
          tooltip={t("product.duplicate")}
          id="action-button"
          tooltipOptions={{
            position: "bottom",
            mouseTrack: true,
            mouseTrackTop: 15,
          }}
          onClick={() => onDuplicate(rowData)}
        />
        <Button
          icon="pi pi-lock"
          disabled={rowData.status === "ARCHIVED"}
          className={`p-button ${rowData.status !== "ACTIVE"
            ? "action-button"
            : "active-action-button"
            }`}
          id="action-button"
          tooltip={rowData.status === "ARCHIVED" ? t("Unarchive") : t("Archive")}
          tooltipOptions={{
            position: "bottom",
            mouseTrack: true,
            mouseTrackTop: 15,
          }}
          onClick={(e) => onArchive(rowData, e)}
        />
        <Button
          icon="pi pi-crown"
          className={`p-button ${hasLeaderboard
            ? "active-action-button leaderboard-active"
            : "action-button leaderboard-inactive"
            }`}
          tooltip={t("products.share_leaderboard")}
          onClick={() => onLeaderboard(rowData)}
        />
        <Button
          id={greyOut ? "disable-share-action-button" : "action-button"}
          icon={!rowData.watcherCount ? "pi pi-eye-slash" : "pi pi-eye"}
          className="action-button"
          tooltip={t("products.product_watchers")}
          onClick={() => onWatchers(rowData)}
        />
      </RoleAccess>
    </div>
  );
};

export default ProductGroupActions;
